import ApiForm from '../apis/components/ApiForms';
import { useState } from 'react';
import { useSearchParams } from 'react-router';
import { useEffect } from 'react';
import ApiCards from '../apis/components/ApiCards';
function APIPublicPage() {
  const [searchParams] = useSearchParams();
  const [selectedApi, setSelectedApi] = useState(null);
  const [responseData, setResponseData] = useState(null);
  const [isAuth, setIsAuth] = useState(true);
  const [selectedTab, setSelectedTab] = useState(
    searchParams.get('category') || 'ALL',
  );
  const tokenParams = searchParams.get('accessToken');
  const styledParam = searchParams.get('styled');
  const styledObject = styledParam
    ? JSON.parse(decodeURIComponent(styledParam))
    : {};

  useEffect(() => {
    if (selectedTab !== searchParams.get('category')) {
      setSelectedTab(searchParams.get('category') || 'ALL');
    }
  }, [searchParams]);

  return (
    <>
      {isAuth && tokenParams ? (
        <>
          {selectedApi?.documentType ? (
            <div className="flex justify-center flex-col py-4 px-20 md:px-4 max-sm:px-5 border-b">
              <ApiForm
                selectedApi={selectedApi}
                responseData={responseData}
                setResponseData={setResponseData}
                styledObject={styledObject}
                setIsAuth={setIsAuth}
                setSelectedApi={setSelectedApi}
              />
            </div>
          ) : (
            <div className="flex justify-center flex-col py-4  px-20 md:px-4 max-sm:px-5 border-b">
              <ApiCards
                setResponseData={setResponseData}
                setSelectedApi={setSelectedApi}
                selectedTab={selectedTab}
                setIsAuth={setIsAuth}
                isWidget={true}
              />
            </div>
          )}
        </>
      ) : (
        <div className="flex items-center justify-center">
          <div className="p-8 flex flex-col items-center text-center">
            <span className="text-6xl font-bold text-red-500">401</span>
            <span className="text-xl font-semibold text-gray-700 mt-2">
              Unauthorized
            </span>
            <span className="text-base text-gray-500 mt-2">
              Please provide a valid token!!
            </span>
          </div>
        </div>
      )}
    </>
  );
}

export default APIPublicPage;
